import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroupAttendance(id?: number, enabled = true) {
  const getGroupAttendanceQuery = useQuery({
    queryKey: [GroupKey.GROUP_ATTENDANCE, id],
    queryFn: () => GroupService.getGroupAttendance(id).then((response) => response.data),
    enabled: enabled && !!id,
  });

  const errorMessage = useErrorMessage(getGroupAttendanceQuery.error, baseErrorMessages);

  return { ...getGroupAttendanceQuery, errorMessage };
}
